import { watchNewNotifications, setLastSeenAtInFB, watchLastSeenAtDateChanges } from "../services/firebaseRealtimeDb";
import { addNotifications } from "../actions/notificationActions";
import { put, takeLatest, select, take } from "redux-saga/effects";
import * as R from "ramda";
import { showNotificationAlert } from "../actions";
import { selectUserId } from "../util/selectors";
import { formatNotification } from "../util/notificationMessages";

function* handleNotificationsChanges({ notifications }) {
  const lastSeenAt = yield select(state => state.notifications.lastSeenAt);
  const prevNotifications = yield select(state => state.notifications.data);
  let aggregatedNotifications = Object.keys(notifications)
    .map(key => {
      const notification = notifications[key];
      const lastUpdatedAt = notification.lastUpdatedAt;
      return {
        ...notification,
        targetId: key.split("_")[0],
        interactionType: key.split("_")[1],
        lastUpdatedAt: -1 * lastUpdatedAt,
        isSeen: lastSeenAt ? -1 * lastUpdatedAt < lastSeenAt : true,
      };
    })
    .map(notification => formatNotification(notification))
    .filter(notification => notification);

  const count = aggregatedNotifications.filter(notification => !notification.isSeen).length;
  yield put(addNotifications(aggregatedNotifications, count));

  if (prevNotifications.length > 0) {
    const isNotificationEqual = (n1, n2) =>
      n1.targetId === n2.targetId && n1.interactionType === n2.interactionType && n1.lastUpdatedAt === n2.lastUpdatedAt;
    let freshNotifications = R.differenceWith(isNotificationEqual, aggregatedNotifications, prevNotifications);
    for (let i = 0; i < freshNotifications.length; i++) {
      yield put(showNotificationAlert(freshNotifications[i]));
    }
  }
}
function* handleSetLastSeenAt() {
  const userId = yield select(selectUserId);
  try {
    yield setLastSeenAtInFB(userId, Date.now());
  } catch (error) {
    console.log("error", error);
  }
}
export function* watchNotificationsChanges(dispatch) {
  // wait for user to login
  let loginAction = yield take("SET_USER");
  yield watchLastSeenAtDateChanges({ dispatch, userId: loginAction.profile.uid });
  yield watchNewNotifications({ dispatch, userId: loginAction.profile.uid });
  yield takeLatest("NOTIFICATIONS_RECIEVED", handleNotificationsChanges);
  yield takeLatest("SHOW_NOTIFICATIONS", handleSetLastSeenAt);
}



// WEBPACK FOOTER //
// ./src/sagas/NotificationSaga.js